<template>
  <div v-if="bookingHistory.length">
    <div
      class="parent-container"
      v-for="(bookingHistoryItem, index) in bookingHistory"
      :key="index"
    >
      <div role="tab">
        <h5 class="panel-title">
          <a
            :class="{
              collapsed:
                bookingHistoryItem?.number_of_children > 0 &&
                bookingHistoryItem?.collapsed,
            }"
            @click="
              bookingHistoryItem?.number_of_children > 0 &&
                getChildren(bookingHistoryItem)
            "
            :data-toggle="
              bookingHistoryItem?.number_of_children > 0 ? 'collapse' : null
            "
            :href="
              bookingHistoryItem?.number_of_children > 0
                ? '#answer' + index
                : null
            "
            :aria-expanded="
              bookingHistoryItem?.number_of_children > 0 ? 'false' : null
            "
            :aria-controls="
              bookingHistoryItem?.number_of_children > 0
                ? 'answer' + index
                : null
            "
          >
            {{ bookingHistoryItem?.text }}
          </a>
        </h5>
      </div>
      <div
        v-show="bookingHistoryItem?.children.length"
        :id="'answer' + index"
        class="panel-collapse collapse"
        role="tabpanel"
      >
        <div
          class="panel-body"
          v-for="(
            bookingHistoryItemChildren, counter
          ) in bookingHistoryItem?.children"
          :key="counter"
        >
          <h5
            v-if="bookingHistoryItemChildren.children.length"
            class="panel-title"
          >
            <a
              class="collapsed"
              data-toggle="collapse"
              :href="'#child-answer' + counter"
              aria-expanded="false"
              :aria-controls="'child-answer' + counter"
            >
              {{ bookingHistoryItemChildren.text }}
            </a>
          </h5>
          <span v-else> {{ bookingHistoryItemChildren.text }}</span>
          <div
            v-if="bookingHistoryItemChildren.children.length"
            :id="'child-answer' + counter"
            class="panel-collapse collapse"
            role="tabpanel"
          >
            <div
              class="panel-body children"
              v-for="(
                bookingHistoryItemChildrenChildren, childCounter
              ) in bookingHistoryItemChildren.children"
              :key="childCounter"
            >
              {{ bookingHistoryItemChildrenChildren.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="inquiry-no-result">
      <img v-if="loading" src="/pic/ajax-loader.gif" />
      <div v-else>
        <br />
        <h3 class="font-bold"><span class="fa fa-ban"></span> There is no history for this booking</h3>
      </div>
    </div>
  </div>
</template>
<script>
import { getSingleTabData } from "@/modules/Booking/api/BookingViewTabs";
import axios from "axios";

export default {
  name: "HistoryTab",
  props: {
    itemType: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      bookingHistory: [],
      loading: true,
    };
  },
  methods: {
    getChildren(bookingHistoryItem) {
      bookingHistoryItem.collapsed = !bookingHistoryItem.collapsed;
      if (!bookingHistoryItem.childrenFetched) {
        let id = bookingHistoryItem.id;
        let url = `/booking/history/${this.itemId}/${id}`;
        if (bookingHistoryItem.source == "customer")
          url = `/customer/history/${bookingHistoryItem.type_id}/${id}`;
        axios.get(url).then((response) => {
          if (response && response.data.childrenHistory) {
            let selectedBookingHistoryItem = this.bookingHistory.find(
              (item) => item.id === id
            );
            if (selectedBookingHistoryItem) {
              this.$set(
                selectedBookingHistoryItem,
                "children",
                response.data.childrenHistory
              );
              selectedBookingHistoryItem.childrenFetched = true;

              // this.bookingHistory.find(item => item.id === id).children = response.data.childrenHistory;
            }
          }
        });
      }
    },
    getSingleTabData() {
      let params = {
        type: "history",
        booking_id: this.itemId,
        fromVuejs: true,
      };
      getSingleTabData(params).then((response) => {
        console.log("------------------------------------");
        this.bookingHistory = response.data.bookingHistory || [];
        console.log(this.bookingHistory.length);
        console.log("++++++++++++++++++++++++++++++++");
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getSingleTabData();
  },
};
</script>

<style scoped>
.tab-content {
  padding: 20px;
}
.parent-container {
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #eaecee;
}
.panel-body {
  border-radius: 12px;
  border: 1px solid #eaecee;
  margin-top: 12px;
  background-color: #f5f5f6;
}
.children {
  background-color: #ffffff;
}
</style>
